<template>
    <v-card class="d-flex flex-column" height="100vh">
        <v-card-title
            v-if="false"
            ref="cardTitle"
            class="text-h5 align-center flex-shrink-0"
        >
            Sales Projection
            <v-spacer></v-spacer>
            <v-btn
                v-if="false"
                small
                color="primary"
                @click="downloadExcel"
                :loading="downloadingExcel"
                class="mr-2"
            >
                <v-icon left small>mdi-download</v-icon>
                Export Excel
            </v-btn>
        </v-card-title>
        <v-card-text
            v-if="internalReportData"
            class="px-0 py-0 flex-grow-1 d-flex flex-column"
            style="min-height: 0; overflow: hidden;"
        >
            <div class="d-flex align-center flex-wrap px-4 pt-2 pb-2">
                <div
                    class="mr-2"
                    style="
                        position: relative;
                        border: 1px solid rgba(0, 0, 0, 0.38);
                        border-radius: 4px;
                        padding: 8px 12px;
                        min-height: 40px;
                    "
                >
                    <span
                        style="
                            position: absolute;
                            top: -9px;
                            left: 8px;
                            background: white;
                            padding: 0 4px;
                            font-size: 12px;
                            color: rgba(0, 0, 0, 0.6);
                        "
                        >Probability</span
                    >
                    <v-chip
                        :color="
                            filterProbability === 'all' ? 'primary' : 'default'
                        "
                        class="mr-2"
                        @click="filterProbability = 'all'"
                    >
                        All
                    </v-chip>
                    <v-chip
                        :color="
                            filterProbability === 'high' ? 'primary' : 'default'
                        "
                        class="mr-2"
                        @click="filterProbability = 'high'"
                    >
                        High
                    </v-chip>
                    <v-chip
                        :color="
                            filterProbability === 'low' ? 'primary' : 'default'
                        "
                        class="mr-2"
                        @click="filterProbability = 'low'"
                    >
                        Low
                    </v-chip>
                </div>
                <div class="filter-field-wrap mr-2">
                    <v-combobox
                        v-model="filterCustomerIds"
                        :items="filterCustomerOptions"
                        item-text="name"
                        item-value="id"
                        label="Customer"
                        multiple
                        hide-details
                        dense
                        outlined
                        clearable
                        class="customer-filter-combobox"
                    >
                        <template v-slot:selection="{ index }">
                            <div
                                v-if="index === 0"
                                class="customer-selection-container"
                            >
                                <span
                                    v-if="filterCustomerIds.length > 1"
                                    class="customer-selection-text"
                                    >Clients</span
                                >
                                <span v-else class="customer-selection-text"
                                    >{{ filterCustomerIds[0].name }}
                                </span>
                                <v-badge
                                    v-if="index === 0"
                                    :content="filterCustomerIds.length"
                                    :value="filterCustomerIds.length > 0"
                                    color="primary"
                                    class="customer-selection-badge"
                                    overlap
                                >
                                </v-badge>
                            </div>
                        </template>
                    </v-combobox>
                </div>
                <div class="filter-field-wrap mr-2">
                    <v-combobox
                        v-model="filterAccountManagerIds"
                        :items="filterAccountManagerOptions"
                        item-text="name"
                        item-value="id"
                        label="Account Manager"
                        multiple
                        hide-details
                        dense
                        outlined
                        clearable
                        class="customer-filter-combobox"
                    >
                        <template v-slot:selection="{ index }">
                            <div
                                v-if="index === 0"
                                class="customer-selection-container"
                            >
                                <span
                                    v-if="filterAccountManagerIds.length > 1"
                                    class="customer-selection-text"
                                    >Managers</span
                                >
                                <span v-else class="customer-selection-text"
                                    >{{ filterAccountManagerIds[0].name }}
                                </span>
                                <v-badge
                                    v-if="index === 0"
                                    :content="filterAccountManagerIds.length"
                                    :value="filterAccountManagerIds.length > 0"
                                    color="primary"
                                    class="customer-selection-badge"
                                    overlap
                                >
                                </v-badge>
                            </div>
                        </template>
                    </v-combobox>
                </div>
                <div class="filter-field-wrap mr-2">
                    <v-text-field
                        v-model="quoteSearchText"
                        label="Quote"
                        dense
                        outlined
                        hide-details
                        clearable
                        style="max-width: 280px;"
                        @input="applyFiltersAndProcess"
                        @clear="applyFiltersAndProcess"
                    />
                </div>
                <v-spacer />
                <v-btn icon @click="closeDialog" class="mr-2">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <v-data-table
                :headers="headers"
                :items="flattenedData"
                disable-pagination
                id="virtual-scroll-table"
                hide-default-footer
                hide-default-header
                :mobile-breakpoint="0"
                fixed-header
                class="sales-projection-table flex-grow-1"
                dense
            >
                <!-- Custom header con dos niveles -->
                <template v-slot:header>
                    <thead class="v-data-table-header">
                        <!-- Primera fila: Quarters -->
                        <tr>
                            <th
                                class="text-left sticky-phantom"
                                style="width: 700px; padding: 0 !important; background-color: white !important;"
                            >
                                <div
                                    class="d-flex align-center"
                                    style="width: 400px; padding: 8px; height: 100%; background-color: white;"
                                >
                                    <span class="text-h6 font-weight-bold"
                                        >Sales Projection</span
                                    >
                                </div>
                            </th>
                            <th
                                rowspan="2"
                                class="text-center quarter-header"
                                style="width: 90px;"
                            >
                                Probability
                            </th>
                            <th
                                v-for="quarter in quarters"
                                :key="quarter"
                                colspan="2"
                                class="text-center quarter-header"
                                style="border-bottom: 1px solid rgba(0,0,0,0.12);"
                            >
                                {{ quarter }}
                            </th>
                            <th
                                rowspan="2"
                                class="text-end"
                                style="width: 150px;"
                            >
                                Total Price
                            </th>
                            <th
                                rowspan="2"
                                class="text-end"
                                style="width: 100px;"
                            >
                                Total %
                            </th>
                        </tr>
                        <!-- Segunda fila: Price y % -->
                        <tr>
                            <!-- Primera columna con el texto -->
                            <th
                                class="text-left"
                                style="width: 700px; font-size: 1.1rem; font-weight: bold;"
                            >
                                State/Client/Project
                            </th>
                            <template v-for="quarter in quarters">
                                <th
                                    :key="`${quarter}_price`"
                                    class="text-end sub-header price-header "
                                    style="width: 120px; "
                                >
                                    Price
                                </th>
                                <th
                                    :key="`${quarter}_pct`"
                                    class="text-end sub-header pct-header"
                                    style="width: 80px;"
                                >
                                    %
                                </th>
                            </template>
                        </tr>
                    </thead>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                    <div
                        :style="{
                            paddingLeft: `${
                                item.type == 'project' ? 0 : item.level * 24
                            }px`,
                            fontWeight: item.level < 3 ? 'bold' : 'normal',
                            width: '100%',
                            boxSizing: 'border-box',
                            display: 'flex',
                            alignItems: 'center',
                        }"
                        :class="getRowClass(item)"
                    >
                        <span
                            v-if="item.children && item.children.length > 0"
                            @click="toggleExpand(item.id)"
                            style="cursor: pointer; user-select: none;"
                            class="mr-2"
                        >
                            {{ item.expanded ? '▼' : '▶' }}
                        </span>
                        <span
                            v-else
                            class="mr-2"
                            style="display: inline-block; width: 20px;"
                        ></span>
                        <span
                            v-if="item.type === 'project'"
                            @click="onOpenQuoteFollowUp(item)"
                            style="cursor: pointer; text-decoration: underline; flex: 1; min-width: 0;"
                        >
                            {{ item.name }}
                        </span>
                        <span v-else style="flex: 1; min-width: 0;">{{
                            item.name
                        }}</span>
                    </div>
                </template>

                <template v-slot:[`item.probability`]="{ item }">
                    <v-chip
                        v-if="item.probability"
                        small
                        :color="defineColor(item.probability)"
                        class="white--text"
                    >
                        {{
                            item.probability.charAt(0).toUpperCase() +
                                item.probability.slice(1)
                        }}
                    </v-chip>
                </template>

                <!-- Templates para valores de quarters -->
                <template
                    v-for="quarter in quarters"
                    v-slot:[`item.${quarter}_value`]="{ item }"
                >
                    <span
                        :key="`${quarter}_value`"
                        class="text-end font-weight-bold d-block price-header"
                        :style="
                            item.type === 'project'
                                ? 'cursor: pointer; text-decoration: underline;'
                                : ''
                        "
                        @click="
                            item.type === 'project' && onOpenQuoteFollowUp(item)
                        "
                    >
                        {{
                            (item.quarters[quarter]?.value || 0) > 0
                                ? formatCurrency(item.quarters[quarter].value)
                                : ''
                        }}
                    </span>
                </template>

                <!-- Templates para porcentajes de quarters -->
                <template
                    v-for="quarter in quarters"
                    v-slot:[`item.${quarter}_percentage`]="{ item }"
                >
                    <span
                        :key="`${quarter}_percentage`"
                        class="text-end d-block"
                    >
                        {{
                            (item.quarters[quarter]?.value || 0) > 0
                                ? formatPercentage(
                                      item.quarters[quarter].percentage || 0
                                  )
                                : ''
                        }}
                    </span>
                </template>

                <template v-slot:[`item.totalUSD`]="{ item }">
                    <div
                        class="text-end font-weight-bold"
                        :style="
                            item.type === 'project'
                                ? 'cursor: pointer; text-decoration: underline;'
                                : ''
                        "
                        @click="
                            item.type === 'project' && onOpenQuoteFollowUp(item)
                        "
                    >
                        {{ formatCurrency(item.totalUSD) }}
                    </div>
                </template>

                <template v-slot:[`item.percentage`]="{ item }">
                    <div class="text-end font-weight-bold">
                        {{
                            item.type !== 'project'
                                ? formatPercentage(item.percentage)
                                : ''
                        }}
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
        <v-card-text v-else class="text-center pa-8">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
            <p class="mt-4">Loading report data...</p>
        </v-card-text>
        <v-dialog
            v-model="followUpDialogVisible"
            persistent
            max-width="900px"
            fullscreen
        >
            <v-card v-if="followUpDialogVisible">
                <v-card-title class="d-flex align-center">
                    <span>Follow Up</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="followUpDialogVisible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="pa-0">
                    <QuoteFollowUp
                        :id="selectedQuoteForFollowUp.id"
                        :quote="selectedQuoteForFollowUp"
                        :settings="settings"
                        :history="false"
                    />
                </v-card-text>
            </v-card>
        </v-dialog>
        <Errors />
    </v-card>
    <!-- </div> -->
    <!-- </v-dialog> -->
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs'
import API from '@/services/api'
import { mapMutations } from 'vuex'
import Errors from '@/components/Layout/Errors.vue'

export default {
    name: 'SalesProjectionReport',
    components: {
        QuoteFollowUp: () => import('@/views/Quotes/QuoteFollowUp.vue'),
        Errors,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        reportData: {
            type: Object,
            default: null,
        },
        companyId: {
            type: String,
            default: null,
        },
        clients: {
            type: Array,
            default: () => [],
        },
        users: {
            type: Array,
            default: () => [],
        },
        settings: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            expandedItems: new Set(),
            processedData: null,
            downloadingExcel: false,
            height: 0,
            hasAutoExpanded: false,
            settingsExchanges: false,
            filterProbability: 'all',
            filterCustomerIds: [],
            filterAccountManagerIds: [],
            quoteSearchText: '',
            internalReportData: null,
            loadingReport: false,
            followUpDialogVisible: false,
            selectedQuoteForFollowUp: null,
        }
    },
    computed: {
        reportDataSource() {
            return this.internalReportData || this.reportData
        },
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
        quarters() {
            if (!this.processedData || !this.processedData.quarters) {
                return []
            }
            return this.processedData.quarters
        },
        headers() {
            const baseHeaders = [
                {
                    text: 'State/Client/Project',
                    value: 'name',
                    sortable: false,
                    width: '700px',
                },
                {
                    text: 'Probability',
                    value: 'probability',
                    sortable: false,
                    width: '90px',
                },
            ]

            // Add quarterly headers - DOS columnas por quarter
            const quarterHeaders = []
            this.quarters.forEach(quarter => {
                quarterHeaders.push({
                    text: quarter,
                    value: `${quarter}_value`,
                    sortable: false,
                    align: 'end',
                    width: '120px',
                    quarter: quarter,
                    isValue: true,
                })
                quarterHeaders.push({
                    text: quarter,
                    value: `${quarter}_percentage`,
                    sortable: false,
                    align: 'end',
                    width: '80px',
                    quarter: quarter,
                    isPercentage: true,
                })
            })

            // Add total headers
            const totalHeaders = [
                {
                    text: 'Total Price',
                    value: 'totalUSD',
                    sortable: false,
                    align: 'end',
                    width: '150px',
                },
                {
                    text: 'Total %',
                    value: 'percentage',
                    sortable: false,
                    align: 'end',
                    width: '100px',
                },
            ]

            return [...baseHeaders, ...quarterHeaders, ...totalHeaders]
        },
        exchangeMap() {
            const settingsExchanges = this.settings.find(
                x => x.name == 'Exchange'
            )
            const exchanges = settingsExchanges?.exchanges || []
            return exchanges.reduce((acc, ex) => {
                const key = (ex?.currency || '').toUpperCase().trim()
                const rate = Number(ex?.money)
                if (key && Number.isFinite(rate) && rate > 0) {
                    acc[key] = rate
                }
                return acc
            }, {})
        },
        filterCustomerOptions() {
            if (
                !this.reportDataSource ||
                !this.reportDataSource.quotes ||
                !Array.isArray(this.reportDataSource.quotes)
            ) {
                return []
            }
            const ids = [
                ...new Set(
                    this.reportDataSource.quotes
                        .map(q => q.clientId)
                        .filter(Boolean)
                ),
            ]
            const options = ids.map(id => ({
                id,
                name: this.getClientName(id),
            }))
            return options.sort((a, b) =>
                (a.name || '').localeCompare(b.name || '', undefined, {
                    sensitivity: 'base',
                })
            )
        },
        filterAccountManagerOptions() {
            if (
                !this.reportDataSource ||
                !this.reportDataSource.quotes ||
                !Array.isArray(this.reportDataSource.quotes)
            ) {
                return []
            }
            const ids = [
                ...new Set(
                    this.reportDataSource.quotes
                        .map(q => q.userId)
                        .filter(Boolean)
                ),
            ]
            const options = ids.map(id => ({
                id,
                name: this.getUserName(id),
            }))
            return options.sort((a, b) =>
                (a.name || '').localeCompare(b.name || '', undefined, {
                    sensitivity: 'base',
                })
            )
        },
        flattenedData() {
            if (!this.processedData || !this.processedData.data) {
                return []
            }

            // Helper function to calculate grand total for a quarter
            const calculateGrandTotalForQuarter = (quarter, items) => {
                const sumRecursive = items => {
                    return items.reduce((sum, item) => {
                        const quarterValue = item.quarters[quarter]?.value || 0
                        if (item.children && item.children.length > 0) {
                            return sum + sumRecursive(item.children)
                        }
                        return sum + quarterValue
                    }, 0)
                }
                return sumRecursive(items)
            }

            const flatten = (items, parentId = '') => {
                let result = []
                let counter = 0

                items.forEach(item => {
                    const id =
                        parentId === ''
                            ? `${counter++}`
                            : `${parentId}-${counter++}`
                    const shouldShow =
                        parentId === '' || this.isParentExpanded(parentId)

                    if (shouldShow) {
                        result.push({
                            ...item,
                            id,
                            expanded: this.expandedItems.has(id),
                        })

                        if (
                            item.children &&
                            item.children.length > 0 &&
                            this.expandedItems.has(id)
                        ) {
                            result = result.concat(flatten(item.children, id))
                        }
                    }
                })

                return result
            }

            // Add grand total row
            const grandTotalRow = {
                id: 'grand-total',
                name: 'TOTAL USD',
                type: 'total',
                level: -1,
                totalUSD: this.processedData.grandTotal || 0,
                percentage: 100,
                quarters: this.quarters.reduce((acc, quarter) => {
                    const quarterTotal = calculateGrandTotalForQuarter(
                        quarter,
                        this.processedData.data
                    )
                    acc[quarter] = {
                        value: quarterTotal,
                        percentage:
                            this.processedData.grandTotal > 0
                                ? (quarterTotal /
                                      this.processedData.grandTotal) *
                                  100
                                : 0,
                    }
                    return acc
                }, {}),
                expanded: false,
            }

            return [...flatten(this.processedData.data), grandTotalRow]
        },
    },
    provide() {
        return {
            replaceQuoteLocal: this.replaceQuoteLocal,
        }
    },
    mounted() {
        const settingsExchanges = this.settings.find(
            setting => setting.name == 'Exchange'
        )
        this.settingsExchanges = settingsExchanges
    },
    watch: {
        reportData: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.quotes && newVal.projections) {
                    // Ensure quotes and projections are arrays
                    const quotes = Array.isArray(newVal.quotes)
                        ? newVal.quotes
                        : []
                    const projections = Array.isArray(newVal.projections)
                        ? newVal.projections
                        : []

                    if (quotes.length > 0 && projections.length > 0) {
                        this.applyFiltersAndProcess()
                    } else {
                        // If no data, set processedData to empty structure
                        this.processedData = {
                            grandTotal: 0,
                            grandTotalPercentage: 100,
                            quarters: [],
                            data: [],
                        }
                    }
                } else {
                    // Reset if data structure is invalid
                    this.processedData = null
                }
            },
        },
        filterProbability() {
            this.applyFiltersAndProcess()
        },
        filterCustomerIds: {
            handler() {
                this.applyFiltersAndProcess()
            },
            deep: true,
        },
        filterAccountManagerIds: {
            handler() {
                this.applyFiltersAndProcess()
            },
            deep: true,
        },
        quoteSearchText() {
            this.applyFiltersAndProcess()
        },
        value: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.hasAutoExpanded = false
                    if (this.companyId) {
                        this.loadReportData()
                    }
                } else {
                    this.expandedItems = new Set()
                    this.hasAutoExpanded = false
                }
            },
        },
        processedData: {
            immediate: true,
            handler() {},
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        async loadReportData() {
            if (!this.companyId) return
            this.loadingReport = true
            try {
                const projections = await API.getAllProjections({})
                const activeProjections = projections.filter(
                    p => p.expectedDate
                )
                const quoteIds = activeProjections.map(p => p.id)
                const quotes = await API.getSimpleQuotesByIds({
                    companyId: this.companyId,
                    quoteIds,
                })
                this.internalReportData = {
                    quotes,
                    projections: activeProjections.filter(projection =>
                        quotes.some(quote => quote.id == projection.id)
                    ),
                }
                this.applyFiltersAndProcess()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
                this.internalReportData = {
                    quotes: [],
                    projections: [],
                }
            } finally {
                this.loadingReport = false
            }
        },
        getQuarterAndYear(date) {
            if (!date) return null
            let dateObj
            if (typeof date === 'object' && date !== null) {
                if (typeof date.toDate === 'function') {
                    dateObj = date.toDate()
                } else {
                    const sec = date._seconds ?? date.seconds
                    if (sec != null) {
                        dateObj = new Date(Number(sec) * 1000)
                    }
                }
            }
            if (!dateObj) {
                const value = Number(date)
                dateObj =
                    !isNaN(value) && value > 0
                        ? new Date(value >= 1e12 ? value : value * 1000)
                        : new Date(date)
            }
            if (isNaN(dateObj.getTime())) return null
            const quarter = Math.floor(dateObj.getMonth() / 3) + 1
            return `Q${quarter} ${dateObj.getFullYear()}`
        },
        convertToUSD(value, currency) {
            const total = Number(value) || 0
            const code = (currency || 'COP').toUpperCase().trim()
            const usdRate = this.exchangeMap.USD || 1
            const sourceToGlobalRate = this.exchangeMap[code]

            if (code === 'USD') return total
            if (sourceToGlobalRate && usdRate > 0) {
                return (total * sourceToGlobalRate) / usdRate
            }
            return total / usdRate
        },
        processData(quotes, projections) {
            // Validate inputs
            if (!quotes || !Array.isArray(quotes) || quotes.length === 0) {
                console.warn('No quotes provided to processData')
                this.processedData = {
                    grandTotal: 0,
                    grandTotalPercentage: 100,
                    quarters: [],
                    data: [],
                }
                return
            }

            if (
                !projections ||
                !Array.isArray(projections) ||
                projections.length === 0
            ) {
                console.warn('No projections provided to processData')
                this.processedData = {
                    grandTotal: 0,
                    grandTotalPercentage: 100,
                    quarters: [],
                    data: [],
                }
                return
            }

            // Create maps for quick lookup
            const quotesMap = new Map()
            quotes.forEach(quote => {
                if (quote && quote.id) {
                    quotesMap.set(quote.id, quote)
                }
            })

            const projectionsMap = new Map()
            projections.forEach(projection => {
                if (projection && projection.id) {
                    projectionsMap.set(projection.id, projection)
                }
            })

            // Build hierarchical structure
            const hierarchy = {}
            let grandTotalUSD = 0
            const quartersSet = new Set()

            projections.forEach(projection => {
                try {
                    if (!projection || !projection.id) {
                        console.warn('Invalid projection data:', projection)
                        return
                    }

                    const quote = quotesMap.get(projection.id)
                    if (!quote) {
                        console.warn(
                            `Quote not found for projection ${
                                projection.id
                            } (Projection name: ${projection.name || 'N/A'})`
                        )
                        // Continue with next projection instead of breaking
                        return
                    }

                    // Validate quote has required fields
                    if (!quote.id) {
                        console.warn(
                            `Quote has no ID for projection ${projection.name}`
                        )
                        return
                    }

                    const clientName = this.getClientName(quote.clientId)
                    const country = quote.country || 'Unknown'
                    const state = quote.state || null
                    // Use quote ID as unique key to prevent grouping quotes with same name
                    const quoteId = quote.id
                    const quoteName =
                        projection.name || quote.name || `Quote ${quote.id}`

                    // Convert to USD
                    const valueUSD = this.convertToUSD(
                        projection.total || 0,
                        projection.currency
                    )

                    // Skip if value is 0 or invalid
                    if (!valueUSD || valueUSD === 0) {
                        return
                    }

                    grandTotalUSD += valueUSD

                    // Get quarter
                    const quarter = this.getQuarterAndYear(
                        projection.expectedDate
                    )
                    if (quarter) {
                        quartersSet.add(quarter)
                    }

                    // Build hierarchy
                    // Level 1: Country
                    if (!hierarchy[country]) {
                        hierarchy[country] = {
                            name: country,
                            type: 'country',
                            totalUSD: 0,
                            percentage: 0,
                            quarters: {},
                            children: {},
                        }
                    }

                    // Level 2: State (only for USA)
                    let stateKey = country
                    if (
                        country &&
                        country.toLowerCase() === 'united states' &&
                        state
                    ) {
                        if (!hierarchy[country].children[state]) {
                            hierarchy[country].children[state] = {
                                name: state,
                                type: 'state',
                                totalUSD: 0,
                                percentage: 0,
                                quarters: {},
                                children: {},
                            }
                        }
                        stateKey = `${country}::${state}`
                    }

                    // Level 3: Client
                    const parentNode =
                        stateKey === country
                            ? hierarchy[country]
                            : hierarchy[country].children[state]

                    if (!parentNode) {
                        return
                    }

                    if (!parentNode.children[clientName]) {
                        parentNode.children[clientName] = {
                            name: clientName,
                            type: 'client',
                            totalUSD: 0,
                            percentage: 0,
                            quarters: {},
                            children: {},
                        }
                    }

                    // Level 4: Quote/Project (each quote is unique by ID)
                    if (!parentNode.children[clientName].children[quoteId]) {
                        parentNode.children[clientName].children[quoteId] = {
                            name: quoteName,
                            type: 'project',
                            totalUSD: 0,
                            percentage: 0,
                            quarters: {},
                            quoteId: quote.id,
                            projectionId: projection.id,
                            probability: (
                                projection.probability || ''
                            ).toLowerCase(),
                        }
                    }

                    // Add values
                    const projectNode =
                        parentNode.children[clientName].children[quoteId]
                    projectNode.totalUSD += valueUSD

                    if (quarter) {
                        if (!projectNode.quarters[quarter]) {
                            projectNode.quarters[quarter] = 0
                        }
                        projectNode.quarters[quarter] += valueUSD
                    }

                    // Update parent totals
                    parentNode.children[clientName].totalUSD += valueUSD
                    if (quarter) {
                        if (
                            !parentNode.children[clientName].quarters[quarter]
                        ) {
                            parentNode.children[clientName].quarters[
                                quarter
                            ] = 0
                        }
                        parentNode.children[clientName].quarters[
                            quarter
                        ] += valueUSD
                    }

                    if (stateKey !== country) {
                        hierarchy[country].children[state].totalUSD += valueUSD
                        if (quarter) {
                            if (
                                !hierarchy[country].children[state].quarters[
                                    quarter
                                ]
                            ) {
                                hierarchy[country].children[state].quarters[
                                    quarter
                                ] = 0
                            }
                            hierarchy[country].children[state].quarters[
                                quarter
                            ] += valueUSD
                        }
                    }

                    hierarchy[country].totalUSD += valueUSD
                    if (quarter) {
                        if (!hierarchy[country].quarters[quarter]) {
                            hierarchy[country].quarters[quarter] = 0
                        }
                        hierarchy[country].quarters[quarter] += valueUSD
                    }
                } catch (error) {
                    console.error(
                        `Error processing projection ${projection?.id ||
                            'unknown'}:`,
                        error
                    )
                    // Continue processing other projections
                    return
                }
            })

            // Calculate percentages and sort
            const sortedQuarters = Array.from(quartersSet).sort((a, b) => {
                const [aQ, aY] = a.split(' ')
                const [bQ, bY] = b.split(' ')
                const aYear = parseInt(aY)
                const bYear = parseInt(bY)

                if (aYear !== bYear) {
                    return aYear - bYear
                }

                const aQuarter = parseInt(aQ.replace('Q', ''))
                const bQuarter = parseInt(bQ.replace('Q', ''))
                return aQuarter - bQuarter
            })

            // Recursive function to calculate percentages and sort
            const calculatePercentagesAndSort = (node, grandTotal) => {
                node.percentage =
                    grandTotal > 0 ? (node.totalUSD / grandTotal) * 100 : 0

                if (node.children) {
                    // Sort children by totalUSD descending
                    const sortedChildren = Object.values(node.children).sort(
                        (a, b) => b.totalUSD - a.totalUSD
                    )

                    sortedChildren.forEach(child => {
                        calculatePercentagesAndSort(child, grandTotal)
                    })

                    // Update node.children with sorted order (use quoteId as key
                    // for project nodes to avoid collisions on duplicate names)
                    node.children = {}
                    sortedChildren.forEach(child => {
                        node.children[child.quoteId || child.name] = child
                    })
                }
            }

            // Calculate percentages and sort hierarchy
            const sortedCountries = Object.values(hierarchy).sort(
                (a, b) => b.totalUSD - a.totalUSD
            )

            sortedCountries.forEach(country => {
                calculatePercentagesAndSort(country, grandTotalUSD)
            })

            // Convert hierarchy to array format
            const convertToArray = (node, level = 0) => {
                const quartersData = {}
                sortedQuarters.forEach(q => {
                    quartersData[q] = {
                        value: node.quarters[q] || 0,
                        percentage:
                            grandTotalUSD > 0
                                ? ((node.quarters[q] || 0) / grandTotalUSD) *
                                  100
                                : 0,
                    }
                })

                const result = {
                    name: node.name,
                    type: node.type,
                    level: level,
                    totalUSD: node.totalUSD,
                    percentage: node.percentage,
                    quarters: quartersData,
                }

                if (node.projectionId) {
                    result.projectionId = node.projectionId
                }
                if (node.quoteId) {
                    result.quoteId = node.quoteId
                }
                if (node.probability !== undefined) {
                    result.probability = node.probability
                }

                if (node.children && Object.keys(node.children).length > 0) {
                    result.children = Object.values(node.children).map(child =>
                        convertToArray(child, level + 1)
                    )
                }

                return result
            }

            const data = sortedCountries.map(country =>
                convertToArray(country, 0)
            )

            this.processedData = {
                grandTotal: grandTotalUSD,
                grandTotalPercentage: 100,
                quarters: sortedQuarters,
                data: data,
            }
        },
        getClientName(clientId) {
            if (this.clients && this.clients.length > 0) {
                const client = this.clients.find(c => c.id === clientId)
                return client ? client.name : clientId || 'Unknown Client'
            }
            return clientId || 'Unknown Client'
        },
        getUserName(userId) {
            if (this.users && this.users.length > 0) {
                const user = this.users.find(u => u.id === userId)
                return user ? user.name : userId || 'Unknown User'
            }
            return userId || 'Unknown User'
        },
        toggleExpand(itemId) {
            const newSet = new Set(this.expandedItems)
            if (newSet.has(itemId)) {
                newSet.delete(itemId)
            } else {
                newSet.add(itemId)
            }
            this.expandedItems = newSet
        },
        isParentExpanded(parentId) {
            if (!parentId) return true
            const parts = parentId.split('-').filter(p => p !== '')
            for (let i = 1; i <= parts.length; i++) {
                const checkId = parts.slice(0, i).join('-')
                if (!this.expandedItems.has(checkId)) {
                    return false
                }
            }
            return true
        },
        getRowClass(item) {
            const classes = []
            if (item.type === 'total') {
                classes.push('blue darken-2 white--text')
            } else if (item.type === 'country') {
                classes.push('blue lighten-4')
            } else if (item.type === 'state') {
                classes.push('blue lighten-5')
            } else if (item.type === 'client') {
                classes.push('grey lighten-4')
            }
            return classes.join(' ')
        },
        formatCurrency(value) {
            if (value === 0 || !value) return '$ 0'
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(value)
        },
        formatPercentage(value) {
            if (value === 0 || !value) return '0%'
            return `${Math.round(value)}%`
        },
        defineColor(status) {
            if (!status) return '#808080'
            const probability = String(status).toLowerCase()
            if (probability === 'high') return '#23bf85'
            if (probability === 'medium') return '#F39C12'
            if (probability === 'low') return '#E74C3C'
            return '#808080'
        },
        closeDialog() {
            this.dialog = false
        },
        replaceQuoteLocal(id, quote) {
            const data = this.reportDataSource
            if (!data || !data.projections) return
            const proj = data.projections.find(p => p.id == id)
            if (proj) {
                proj.probability = quote.probability
                proj.expectedDate = quote.expectedDate
            }
            this.applyFiltersAndProcess()
        },
        applyFiltersAndProcess() {
            const newVal = this.reportDataSource
            if (!newVal) {
                this.processedData = null
                return
            }
            if (!newVal.quotes || !newVal.projections) {
                this.processedData = {
                    grandTotal: 0,
                    grandTotalPercentage: 100,
                    quarters: [],
                    data: [],
                }
                return
            }
            const quotes = Array.isArray(newVal.quotes) ? newVal.quotes : []
            let projections = Array.isArray(newVal.projections)
                ? newVal.projections
                : []
            if (this.filterProbability !== 'all') {
                projections = projections.filter(
                    p =>
                        (p.probability || '').toLowerCase() ===
                        this.filterProbability
                )
            }
            if (this.filterCustomerIds.length > 0) {
                const customerIds = this.filterCustomerIds.map(c =>
                    c && typeof c === 'object' && c.id != null ? c.id : c
                )
                const customerIdSet = new Set(customerIds)
                projections = projections.filter(p => {
                    const quote = quotes.find(
                        q => q.id === p.id || q.id == p.id
                    )
                    return quote && customerIdSet.has(quote.clientId)
                })
            }
            if (this.filterAccountManagerIds.length > 0) {
                const accountManagerIds = this.filterAccountManagerIds.map(u =>
                    u && typeof u === 'object' && u.id != null ? u.id : u
                )
                const accountManagerIdSet = new Set(accountManagerIds)
                projections = projections.filter(p => {
                    const quote = quotes.find(
                        q => q.id === p.id || q.id == p.id
                    )
                    return quote && accountManagerIdSet.has(quote.userId)
                })
            }
            if (this.quoteSearchText?.trim()) {
                const search = this.quoteSearchText.trim().toLowerCase()
                projections = projections.filter(p => {
                    const quote = quotes.find(
                        q => q.id === p.id || q.id == p.id
                    )
                    return (
                        quote &&
                        (quote.name || '').toLowerCase().includes(search)
                    )
                })
            }
            if (quotes.length > 0 && projections.length > 0) {
                this.processData(quotes, projections)
            } else {
                this.processedData = {
                    grandTotal: 0,
                    grandTotalPercentage: 100,
                    quarters: [],
                    data: [],
                }
            }
        },
        onOpenQuoteFollowUp(item) {
            const quoteId = item.quoteId || item.projectionId
            if (
                !quoteId ||
                !this.reportDataSource ||
                !this.reportDataSource.quotes
            )
                return
            const quote = this.reportDataSource.quotes.find(
                q => q.id === quoteId || q.id == quoteId
            )
            if (quote) {
                this.selectedQuoteForFollowUp = quote
                this.followUpDialogVisible = true
            }
        },
        expandAllItems() {
            if (!this.processedData || !this.processedData.data) {
                return
            }

            const newSet = new Set()
            const expandAll = (items, parentId = '') => {
                let counter = 0
                items.forEach(item => {
                    const id =
                        parentId === ''
                            ? `${counter++}`
                            : `${parentId}-${counter++}`
                    if (item.children && item.children.length > 0) {
                        newSet.add(id)
                        expandAll(item.children, id)
                    }
                })
            }
            expandAll(this.processedData.data)
            this.expandedItems = newSet
            this.hasAutoExpanded = true
        },
        downloadExcel() {
            try {
                this.downloadingExcel = true
                const flatData = this.flattenedData

                // Prepare data for Excel
                const excelData = flatData.map(item => {
                    const row = {
                        'State/Client/Project': item.name,
                        'Total Price': item.totalUSD,
                        'Total %': `${Math.round(item.percentage)}%`,
                    }

                    // Add quarterly columns
                    this.quarters.forEach(quarter => {
                        row[quarter + ' Price'] =
                            item.quarters[quarter]?.value || 0
                        row[quarter + ' %'] = `${Math.round(
                            item.quarters[quarter]?.percentage || 0
                        )}%`
                    })

                    return row
                })

                // Create worksheet
                const ws = XLSX.utils.json_to_sheet(excelData)

                // Set column widths
                const colWidths = [
                    { wch: 40 }, // State/Client/Project
                ]
                this.quarters.forEach(() => {
                    colWidths.push({ wch: 15 }) // Quarter Price
                    colWidths.push({ wch: 10 }) // Quarter %
                })
                colWidths.push({ wch: 15 }) // Total Price
                colWidths.push({ wch: 10 }) // Total %

                ws['!cols'] = colWidths

                // Create workbook
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, 'Sales Projection')

                // Export
                XLSX.writeFile(wb, `sales-projection-report.xlsx`)
            } catch (error) {
                console.error('Error generating Excel:', error)
                this.$store.commit('setErrorItems', {
                    source: this.$options.name,
                    message: error.message || 'Error generating Excel file',
                })
            } finally {
                this.downloadingExcel = false
            }
        },
    },
}
</script>

<style scoped>
.filter-field-wrap {
    height: 40px;
    display: flex;
    align-items: stretch;
}
.filter-field-wrap >>> .v-input {
    height: 100% !important;
}
.filter-field-wrap >>> .v-input__control {
    min-height: 40px !important;
}

.customer-filter-combobox {
    width: 280px !important;
    min-width: 280px !important;
    max-width: 280px !important;
}

.customer-selection-container {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    padding-right: 40px;
    min-height: 24px;
}

.customer-selection-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    padding-right: 8px;
}

.customer-selection-badge {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
}

.filter-field-wrap >>> .v-input__slot {
    min-height: 40px !important;
}

.filter-field-wrap >>> .v-select__selections {
    min-height: 40px !important;
    padding: 4px 8px !important;
    flex-wrap: nowrap !important;
}

.filter-field-wrap >>> .v-select__selections input {
    width: 0 !important;
    min-width: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    opacity: 0 !important;
    position: absolute !important;
}

#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}

.sales-projection-table {
    height: 100% !important;
}

.sales-projection-table >>> .v-data-table__wrapper {
    overflow-y: auto !important;
    max-height: 100% !important;
}

.sales-projection-table >>> tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.04) !important;
}

.sales-projection-table >>> .blue.darken-2 {
    background-color: #1976d2 !important;
    color: white !important;
}

.sales-projection-table >>> .blue.lighten-4 {
    background-color: #bbdefb !important;
}

.sales-projection-table >>> .blue.lighten-5 {
    background-color: #e3f2fd !important;
}

.sales-projection-table >>> .grey.lighten-4 {
    background-color: #f5f5f5 !important;
}

.sales-projection-table >>> .quarter-header {
    font-weight: bold !important;
    background-color: #f5f5f5 !important;
    padding: 8px !important;
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}
.sales-projection-table >>> .price-header {
    font-weight: bold !important;
    background-color: #f5f5f5 !important;
    padding: 6px 8px !important;
    border-right: none !important;
    border-left: none !important;
}

.sales-projection-table >>> .sub-header {
    font-size: 0.85rem !important;
    font-weight: 500 !important;
    background-color: #fafafa !important;
}

.sales-projection-table
    >>> tbody
    tr
    td:nth-child(even):not(:last-child):not(:nth-last-child(2)) {
    border-right: none !important;
    padding-right: 8px !important;
}

.sales-projection-table
    >>> tbody
    tr
    td:nth-child(odd):not(:first-child):not(:nth-last-child(1)) {
    padding-left: 0px !important;
}

.sales-projection-table >>> thead tr:nth-child(2) th.price-header {
    padding: 6px 8px !important;
}

.sales-projection-table >>> thead tr:nth-child(2) th.pct-header {
    padding: 6px 8px 6px 8px !important;
}

.sales-projection-table >>> tbody tr td.text-end {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.sales-projection-table >>> thead tr:first-child th.quarter-header {
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.sales-projection-table >>> thead tr:nth-child(2) th.pct-header {
    border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
    border-left: none !important;
}

/* ===== Sticky Headers (scroll vertical) ===== */
.sales-projection-table >>> thead {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
}

/* Primera fila de headers - Quarters */
.sales-projection-table >>> thead tr:first-child th {
    position: sticky !important;
    top: 0 !important;
    z-index: 9 !important;
    background-color: white !important;
    padding: 8px !important;
}

/* Segunda fila de headers - Price y % */
.sales-projection-table >>> thead tr:nth-child(2) th {
    position: sticky !important;
    top: 32px !important;
    z-index: 8 !important;
    background-color: white !important;
    padding: 6px 8px !important;
}

.sales-projection-table >>> tbody tr td:first-child {
    position: sticky !important;
    left: 0 !important;
    z-index: 5 !important;
    background-color: white !important;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;
}

.sales-projection-table >>> thead tr:first-child th.sticky-phantom,
.sales-projection-table >>> thead tr:first-child th:first-child {
    position: sticky !important;
    left: 0 !important;
    z-index: 15 !important;
    background-color: white !important;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;
}

.sales-projection-table >>> thead tr:nth-child(2) th:first-child {
    position: sticky !important;
    left: 0 !important;
    z-index: 15 !important;
    background-color: white !important;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;
}

.sales-projection-table >>> thead tr:first-child th:nth-last-child(1),
.sales-projection-table >>> thead tr:first-child th:nth-last-child(2) {
    z-index: 12 !important;
}

.sales-projection-table >>> tbody tr .blue.darken-2:first-child {
    background-color: #1976d2 !important;
}

.sales-projection-table >>> tbody tr .blue.lighten-4:first-child {
    background-color: #bbdefb !important;
}

.sales-projection-table >>> tbody tr .blue.lighten-5:first-child {
    background-color: #e3f2fd !important;
}

.sales-projection-table >>> tbody tr .grey.lighten-4:first-child {
    background-color: #f5f5f5 !important;
}

.sales-projection-table >>> tbody tr:hover td:first-child {
    box-shadow: 3px 0 6px rgba(0, 0, 0, 0.15) !important;
}
</style>
